"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var Product = require('../../../products/interfaces/Product');

var WaxSeal = require('../../../products/components/WaxSeal');

function WaxSealDetails(_ref) {
  var products = _ref.products,
      children = _ref.children;
  var totalsByStyle = {};
  products.forEach(function (product) {
    return product.subcomponents().forEach(function (component) {
      if (Object.prototype.isPrototypeOf.call(WaxSeal.prototype, component) && component.quantity > 0) {
        var quantity = component.quantity,
            wax_seal_style = component.wax_seal_style;

        if (totalsByStyle[wax_seal_style] == null) {
          totalsByStyle[wax_seal_style] = quantity;
        } else {
          totalsByStyle[wax_seal_style] += quantity;
        }
      }
    });
  });
  var waxSeals = Object.keys(totalsByStyle).map(function (wax_seal_style) {
    var quantity = totalsByStyle[wax_seal_style];
    return /*#__PURE__*/React.createElement("span", {
      key: wax_seal_style
    }, "Wax Seals: ", quantity, /*#__PURE__*/React.createElement("br", null), wax_seal_style.replace(' ', ' - '), /*#__PURE__*/React.createElement("br", null), children);
  });

  if (waxSeals.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", null, waxSeals, children);
}

WaxSealDetails.propTypes = {
  products: PropTypes.arrayOf(PropTypes.instanceOf(Product)),
  children: PropTypes.any
};
module.exports = WaxSealDetails;